//import 'ol/ol.css';
//import 'ol/ol.css';
import { INode, FeatureType, ICAMSKey, IAPIResult, TextPack } from '../Shared/Models/UtilityModels';
import * as toastr from "toastr";
import { Utilities, ModalAction } from '../Shared/Utility/Utilities';
import * as events from '../Shared/Bus/Bus';
import { ContactListConfig, ICAMSContact } from '../Shared/Contacts/ContactsModels';
import { Photos } from '../Shared/Photos/Photos';

export enum jqc {
    placeholder_for_modals = '#placeholder-for-modals',
    placeholder_for_legalmodals = '#placeholder-for-legalmodals',
    placeholder_for_legalmodals2= '#placeholder-for-legalmodals2',

    legalEventsEditModal = '#legalEventsEditModal',
    legalEventsEditConsultationsPrintBtn = '#legalEventsEditConsultationsPrintBtn',
    legalEventsEditConsultationsAddBtn = '#legalEventsEditConsultationsAddBtn',
    legalEventsEditConsultationsEditBtn = '#legalEventsEditConsultationsEditBtn',
    legalEventsEditConsultationsDeleteBtn = '#legalEventsEditConsultationsDeleteBtn',
    legalEventsEditConsultationsExportBtn = '#legalEventsEditConsultationsExportBtn',
    legalEventsEditConsultationsTable = '#legalEventsEditConsultationsTable',
    legalEventsEdit_ConsultationEditModal = '#legalEventsEdit_ConsultationEditModal',
    legalEventsEdit_ConsultationEdit_StatutoryConsultee_Count = '#legalEventsEdit_ConsultationEdit_StatutoryConsultee_Count',
    legalEventsEdit_ConsultationEdit_OtherConsultee_Count ='#legalEventsEdit_ConsultationEdit_OtherConsultee_Count',

    legalEventsEdit_ConsultationEdit_AddConsulteeModal = '#legalEventsEdit_ConsultationEdit_AddConsulteeModal',
    legalEventsEdit_ConsultationEdit_AddConsulteeModal_contactSearch = '#legalEventsEdit_ConsultationEdit_AddConsulteeModal_contactSearch',
    legalEventsEdit_ConsultationEdit_AddConsulteeModalSubmitBtn = '#legalEventsEdit_ConsultationEdit_AddConsulteeModalSubmitBtn',
    legalEventsEdit_ConsultationEdit_AddConsulteeModalCloseBtn = '#legalEventsEdit_ConsultationEdit_AddConsulteeModalCloseBtn',
    legalEventsEdit_ConsultationEdit_AddConsulteeModalCancelBtn = '#legalEventsEdit_ConsultationEdit_AddConsulteeModalCancelBtn',
    legalEventsEdit_ConsultationEditModal_StatutoryConsultees_AddPanel = '#legalEventsEdit_ConsultationEditModal_StatutoryConsultees_AddPanel',
    legalEventsEdit_ConsultationEdit_AddConsultee_contactSearch = '#legalEventsEdit_ConsultationEdit_AddConsultee_contactSearch',
    legalEventsEdit_ConsultationEdit_AddConsultee_SingleContactBtn = '#legalEventsEdit_ConsultationEdit_AddConsultee_SingleContactBtn',
    legalEventsEdit_ConsultationEdit_AddConsultee_GroupContactBtn = '#legalEventsEdit_ConsultationEdit_AddConsultee_GroupContactBtn',
    legalEventsEdit_ConsultationEdit_AddConsulteeOther_contactSearch = '#legalEventsEdit_ConsultationEdit_AddConsulteeOther_contactSearch',
    legalEventsEdit_ConsultationEdit_AddConsulteeOther_SingleContactBtn = '#legalEventsEdit_ConsultationEdit_AddConsulteeOther_SingleContactBtn',
    legalEventsEdit_ConsultationEdit_AddConsulteeOther_GroupContactBtn = '#legalEventsEdit_ConsultationEdit_AddConsulteeOther_GroupContactBtn',
    legalEventsEdit_ConsultationEditModal_OwnerConsultees_AddPanel = '#legalEventsEdit_ConsultationEditModal_OwnerConsultees_AddPanel',
    legalEventsEdit_ConsultationEdit_AddConsulteeOther_ManualAddressBtn = '#legalEventsEdit_ConsultationEdit_AddConsulteeOther_ManualAddressBtn',

    legalEventsEdit_ConsultationEditCopyBtn = '#legalEventsEdit_ConsultationEditCopyBtn',
    legalEventsEdit_ConsultationEditAddBtn = '#legalEventsEdit_ConsultationEditAddBtn',
    legalEventsEdit_ConsultationEditDeleteBtn = '#legalEventsEdit_ConsultationEditDeleteBtn',
    legalEventsEdit_ConsultationEditPrintBtn ='#legalEventsEdit_ConsultationEditPrintBtn',
    legalEventsEdit_ConsultationEditEditBtn = '#legalEventsEdit_ConsultationEditEditBtn',
    legalEventsEdit_ConsultationEdit_ConsulteeTable = '#legalEventsEdit_ConsultationEdit_ConsulteeTable',
    legalEventsEdit_ConsultationAddModal = '#legalEventsEdit_ConsultationAddModal',
    legalEventsEdit_ConsultationAddSubmitBtn = '#legalEventsEdit_ConsultationAddSubmitBtn',
    legalEventsEdit_ConsultationAddForm = '#legalEventsEdit_ConsultationAddForm',
    legalEventsEdit_ConsultationAddCloseBtn = '#legalEventsEdit_ConsultationAddCloseBtn',
    legalEventsEdit_ConsultationEditConsultBtn = '#legalEventsEdit_ConsultationEditConsultBtn',
    legalEventsEdit_ConsultationAddCancelBtn = '#legalEventsEdit_ConsultationAddCancelBtn',
    legalEventsEdit_ConsultationEditSubmitBtn = '#legalEventsEdit_ConsultationEditSubmitBtn',
    legalEventsEdit_ConsultationEditForm = '#legalEventsEdit_ConsultationEditForm',
    legalEventsEdit_ConsultationEditCloseBtn = '#legalEventsEdit_ConsultationEditCloseBtn',
    legalEventsEdit_ConsultationEditCancelBtn = '#legalEventsEdit_ConsultationEditCancelBtn',

    consulteeResponseModal = '#consulteeResponseModal',
    consulteeResponseForm = '#consulteeResponseForm',
    consulteeResponseCloseBtn = '#consulteeResponseCloseBtn',
    consulteeResponseCancelBtn = '#consulteeResponseCancelBtn',
    consulteeResponseSubmitBtn = '#consulteeResponseSubmitBtn',
    consulteeResponseDraftBtn = '#consulteeResponseDraftBtn',
    consulteeResponseForm_singleContact = '#consulteeResponseForm [name="singleContact"]',
    consulteeResponseForm_contactSearch = '#consulteeResponseForm [name="contactSearch"]',
    consulteeResponseOtherModal = '#consulteeResponseOtherModal',
    consulteeResponseOtherForm = '#consulteeResponseOtherForm',
    consulteeResponseOtherSubmitBtn = '#consulteeResponseOtherSubmitBtn',
    consulteeResponseOtherCloseBtn = '#consulteeResponseOtherCloseBtn',
    consulteeResponseOtherCancelBtn = '#consulteeResponseOtherCancelBtn',

    legalEventsEdit_ConsultationEdit_ConsulteeOtherTable = '#legalEventsEdit_ConsultationEdit_ConsulteeOtherTable',
    legalEventsEdit_ConsultationOtherEditCopyBtn = '#legalEventsEdit_ConsultationOtherEditCopyBtn',
    legalEventsEdit_ConsultationOtherEditImportBtn = '#legalEventsEdit_ConsultationOtherEditImportBtn',
    legalEventsEdit_ConsultationOtherEditAddBtn = '#legalEventsEdit_ConsultationOtherEditAddBtn',
    legalEventsEdit_ConsultationOtherEditEditBtn = '#legalEventsEdit_ConsultationOtherEditEditBtn',
    legalEventsEdit_ConsultationOtherEditDeleteBtn = '#legalEventsEdit_ConsultationOtherEditDeleteBtn',
    legalEventsEdit_ConsultationOtherEditPrintBtn = '#legalEventsEdit_ConsultationOtherEditPrintBtn'

}

declare let moment: any; // Date helper from moment()

export class LegalEvents_Consultations {
    // ----------------------------------------------------------- //
    // GLOBAL VARS
    private photos: Photos = new Photos();

    // List of buttions in the action toolbar
    private actionStageBtns = {
        viewprint: { btn: null, enable: false },
        new: { btn: null, enable: false },
        edit: { btn: null, enable: false },
        delete: { btn: null, enable: false },
        export: { btn: null, enable: false }
    };

    private actionConsultationBtns = {
        copy: { btn: null, enable: false },
        new: { btn: null, enable: false },
        delete: { btn: null, enable: false },
        edit: { btn: null, enable: false },
        print: { btn: null, enable: false }
    };

    private actionConsultationOtherBtns = {
        copy: { btn: null, enable: false },
        new: { btn: null, enable: false },
        delete: { btn: null, enable: false },
        edit: { btn: null, enable: false },
        print: { btn: null, enable: false },
        import: { btn: null, enable: false }
    };

    // ----------------------------------------------------------- //

    // ----------------------------------------------------------- //
    // Defaults

    // ----------------------------------------------------------- //
    //Constructor
    public constructor() {

    }

    public initEvents = (data: ICAMSKey): void => {
        const self = this;

        // Initialize btns
        self.actionStageBtns = {
            viewprint: { btn: $(jqc.legalEventsEditConsultationsPrintBtn+' button'), enable: false },
            new: { btn: $(jqc.legalEventsEditConsultationsAddBtn +' button'), enable: false },
            edit: { btn: $(jqc.legalEventsEditConsultationsEditBtn +' button'), enable: false },
            delete: { btn: $(jqc.legalEventsEditConsultationsDeleteBtn +' button'), enable: false },
            export: { btn: $(jqc.legalEventsEditConsultationsExportBtn +' button'), enable: false }
        };

        self.actionStageBtns.viewprint.btn.on('click', function () { toastr.info('To be completed'); });
        self.actionStageBtns.new.btn.on('click', function () { self.openAddConsultationModal(data.code); });
        self.actionStageBtns.edit.btn.on('click', function () {
            var table: any = Utilities.GetControl(jqc.legalEventsEditConsultationsTable)
            let rows: Array<any> = table.bootstrapTable('getSelections');
            self.openEditConsultationModal(data.code, rows[0].ConsultationID);
        });
        self.actionStageBtns.delete.btn.on('click', function () {
            //let promptData: IPromptYesNoViewModel = { title: "Confirm", body: "Are you sure you want to remove the selected Consultees from the Consultation?", yesBtn: "Yes", noBtn: "No" };
            //Utilities.GetControl(jqc.placeholder_for_promptModals).load('/PromptModals/PromptYesNoModal', promptData, function (response, status, xhr) {
            //    Utilities.GetModal(jqc.promptYesNoModal, ModalAction.Create);
            //    Utilities.GetControl(jqc.promptModalYesBtn).on('click', function (evt) { evt.preventDefault(); Utilities.GetModal(jqc.promptYesNoModal, ModalAction.Hide); doDelete(); });
            //    Utilities.GetControl(jqc.promptModalNoBtn).on('click', function (evt) { evt.preventDefault(); Utilities.GetModal(jqc.promptYesNoModal, ModalAction.Hide); });
            //});

            function doDelete() {
                var table: any = Utilities.GetControl(jqc.legalEventsEditConsultationsTable)
                let rows: Array<any> = table.bootstrapTable('getSelections');
                self.DeleteConsulation(rows[0].ConsultationID, data.code);
            }
        });
        self.actionStageBtns.export.btn.on('click', function () { toastr.info('To be completed'); });

        // Inituialize table
        var table: any = Utilities.GetControl(jqc.legalEventsEditConsultationsTable)
        table.bootstrapTable();

        table.on('check.bs.table', function (e, row, $element) {
            self.checkVisibleButtons_StageTable();
        });
        table.on('check-all.bs.table', function (e, rowsAfter, rowsBefore) {
            self.checkVisibleButtons_StageTable();
        });
        table.on('uncheck.bs.table', function (e, row, $element) {
            self.checkVisibleButtons_StageTable();
        });
        table.on('uncheck-all.bs.table', function (e, rowsAfter, rowsBefore) {
            self.checkVisibleButtons_StageTable();
        });

        self.GetLegalConsultationData(data);
    }

    // ----------------------------------------------------------- //
    // OPEN PANELS
    public openAddConsulteeModal = (legalCode: string, consultationID: number, addStatutoryInstead: Boolean): void => {
        const self = this;

        // User a different URL depending on if you are adding statutory or other consultees
        var url = "/Consultations/AddConsulteeOthers";
        if (addStatutoryInstead == true) url = "/Consultations/AddConsultees";

        Utilities.BlockUI();
        Utilities.GetModal(jqc.legalEventsEdit_ConsultationEditModal, ModalAction.Hide);
        Utilities.GetControl(jqc.placeholder_for_legalmodals2).load('/Legal/LegalEventsEdit_ConsultationEdit_AddConsulteeView', { consultationID: consultationID }, function (response, status, xhr) {
            if (xhr.status === 401) {//redirect to login in unauthorised
                window.location.href = window.G_SITEFOLDERNAME +'/account/login?ReturnUrl=' + encodeURIComponent(window.location.pathname);
            }
            Utilities.UnBlockUI();

            Utilities.GetModal(jqc.legalEventsEdit_ConsultationEdit_AddConsulteeModal, ModalAction.Create);

            // Fire off the contact search and listen for the results
            Utilities.GetControl(jqc.legalEventsEdit_ConsultationEdit_AddConsulteeModal_contactSearch).on('click', function () {
                // Open the contacts list view
                let btns = new ContactListConfig();
                btns.ActionBtns.account.visible = false;
                btns.ActionBtns.export.visible = false;
                btns.ActionBtns.query.visible = false;
                btns.ActionBtns.viewprint.visible = false;
                btns.AllowMultipleSelection = true;
                events.bus.publish(events.eventOpenContactsListView([false, btns, callback]));

                function callback(contact: Array<ICAMSContact>) {
                    var contactList = contact.map(c => c.ContactRef).join(',');
                    var listName = contact.map(c => c.ListName).join(', ');
                    $(jqc.legalEventsEdit_ConsultationEdit_AddConsulteeModal + ' [name="singleContact"]').val(listName);
                    $(jqc.legalEventsEdit_ConsultationEdit_AddConsulteeModal + ' [name="singleContact_ContactRef"]').val(contactList);                    
                }
            });

            Utilities.GetControl(jqc.legalEventsEdit_ConsultationEdit_AddConsulteeModalSubmitBtn).on('click', function (evt) {
                let query: Array<any> = [];
                var contactType = $(jqc.legalEventsEdit_ConsultationEdit_AddConsulteeModal + ' [name="groupContact"]').val().toString();
                var contactRefs = $(jqc.legalEventsEdit_ConsultationEdit_AddConsulteeModal + ' [name="singleContact_ContactRef"]').val().toString().split(',');
                contactRefs.forEach(function (c) {
                    if (c != "" && c != null) query.push({ ConsultationID: consultationID, ContactRef: c });
                });

                Utilities.BlockUI($(jqc.legalEventsEdit_ConsultationEdit_AddConsulteeModal + " .modal-content"));
                $.post(url, { data: query, contactType: contactType, consultationID: consultationID },
                    function (result: IAPIResult) {
                        Utilities.UnBlockUI($(jqc.legalEventsEdit_ConsultationEdit_AddConsulteeModal + " .modal-content"));
                        try {
                            if (result.success == true) {
                                toastr.info('Added consultee!')
                                Utilities.GetModal(jqc.legalEventsEdit_ConsultationEdit_AddConsulteeModal, ModalAction.Hide);
                                Utilities.GetModal(jqc.legalEventsEdit_ConsultationEditModal, ModalAction.Show);
                                if (addStatutoryInstead == true) {
                                    self.GetLegalConsulteeData(consultationID);
                                } else {
                                    self.GetLegalConsulteeOtherData(consultationID);
                                }
                            }
                            else {
                                if (result.message == null) toastr.error('Failed to add consultee!');
                                else toastr.error(result.message);
                            }
                        }
                        catch (err) {
                            console.log(err);
                            alert(err);
                        }
                    }
                ).fail(function (xhr) {
                    if (xhr.status === 401) {//redirect to login in unauthorised
                        window.location.href = window.G_SITEFOLDERNAME +'/account/login?ReturnUrl=' + encodeURIComponent(window.location.pathname);
                    }
                });
            });

            Utilities.GetControl(jqc.legalEventsEdit_ConsultationEdit_AddConsulteeModalCloseBtn).on('click', function (evt) {
                Utilities.GetModal(jqc.legalEventsEdit_ConsultationEdit_AddConsulteeModal, ModalAction.Hide);
                Utilities.GetModal(jqc.legalEventsEdit_ConsultationEditModal, ModalAction.Show);
            });

            Utilities.GetControl(jqc.legalEventsEdit_ConsultationEdit_AddConsulteeModalCancelBtn).on('click', function (evt) {
                Utilities.GetModal(jqc.legalEventsEdit_ConsultationEdit_AddConsulteeModal, ModalAction.Hide);
                Utilities.GetModal(jqc.legalEventsEdit_ConsultationEditModal, ModalAction.Show);
            });
        });
    }

    public openEditConsulteeModal = (consultationID: number, contactRef: string): void => {
        const self = this;

        Utilities.BlockUI();
        Utilities.GetModal(jqc.legalEventsEdit_ConsultationEditModal, ModalAction.Hide);
        Utilities.GetControl(jqc.placeholder_for_legalmodals2).load('/Consultations/ConsulteeResponseView', { consultationID: consultationID, contactRef: contactRef, showResponseDate: true }, function (response, status, xhr) {
            if (xhr.status === 401) {//redirect to login in unauthorised
                window.location.href = window.G_SITEFOLDERNAME +'/account/login?ReturnUrl=' + encodeURIComponent(window.location.pathname);
            }
            Utilities.UnBlockUI();

            Utilities.GetModal(jqc.consulteeResponseModal, ModalAction.Create);

            // Save the original state of the edit form
            var originalFormData = Utilities.GetControl(jqc.consulteeResponseForm).serialize();

            Utilities.GetControl(jqc.consulteeResponseForm_contactSearch).on('click', function (evt) {
                function callback(c: Array<ICAMSContact>) {
                    Utilities.GetControl(jqc.consulteeResponseForm_singleContact).val(c[0].ListName);
                    Utilities.GetControl(jqc.consulteeResponseForm + ' [name="ContactRef"]').val(c[0].ContactRef);
                    Utilities.GetControl(jqc.consulteeResponseForm + ' [name="NameAddress"]').val(c[0].ListName);
                }

                // Open the contacts list view
                let btns = new ContactListConfig();
                btns.ActionBtns.account.visible = false;
                btns.ActionBtns.export.visible = false;
                btns.ActionBtns.query.visible = false;
                btns.ActionBtns.viewprint.visible = false;
                btns.AllowMultipleSelection = false;
                events.bus.publish(events.eventOpenContactsListView([false, btns, callback]));
            });

            Utilities.GetControl(jqc.consulteeResponseDraftBtn).hide();
            Utilities.GetControl(jqc.consulteeResponseSubmitBtn).on('click', function (evt) {
                var data = {};
                var formData = Utilities.GetControl(jqc.consulteeResponseForm).serializeArray();
                formData.forEach(d => data[d.name] = d.value);
                data['ResponseDate'] = new Date(Date.now()).toLocaleString().split(',')[0];

                let url = "/Consultations/UpdateConsulteeResponse";
                let query = { data: data };

                $.post(url, query,
                    function (result: IAPIResult) {
                        try {
                            if (result.success == true) {
                                toastr.info('Updated response!')
                                Utilities.GetModal(jqc.consulteeResponseModal, ModalAction.Hide);
                                Utilities.GetModal(jqc.legalEventsEdit_ConsultationEditModal, ModalAction.Show);
                                self.GetLegalConsulteeData(consultationID);
                            }
                            else {
                                toastr.info('Failed to update response!')
                            }
                        }
                        catch (err) {
                            console.log(err);
                            alert(err);
                        }
                    }
                ).fail(function (xhr) {
                    if (xhr.status === 401) {//redirect to login in unauthorised
                        window.location.href = window.G_SITEFOLDERNAME +'/account/login?ReturnUrl=' + encodeURIComponent(window.location.pathname);
                    }
                });
            });

            Utilities.GetControl(jqc.consulteeResponseCloseBtn).on('click', function (evt) {
                if (originalFormData !== Utilities.GetControl(jqc.consulteeResponseForm).serialize()) {
                    Utilities.CloseFormWithPrompt().then(r => {
                        if (r == true) {
                            Utilities.GetModal(jqc.consulteeResponseModal, ModalAction.Hide);
                            Utilities.GetModal(jqc.legalEventsEdit_ConsultationEditModal, ModalAction.Show);
                        }
                    });
                }
                else {
                    Utilities.GetModal(jqc.consulteeResponseModal, ModalAction.Hide);
                    Utilities.GetModal(jqc.legalEventsEdit_ConsultationEditModal, ModalAction.Show);
                }
            });

            Utilities.GetControl(jqc.consulteeResponseCancelBtn).on('click', function (evt) {
                if (originalFormData !== Utilities.GetControl(jqc.consulteeResponseForm).serialize()) {
                    Utilities.CloseFormWithPrompt().then(r => {
                        if (r == true) {
                            Utilities.GetModal(jqc.consulteeResponseModal, ModalAction.Hide);
                            Utilities.GetModal(jqc.legalEventsEdit_ConsultationEditModal, ModalAction.Show);
                        }
                    });
                }
                else {
                    Utilities.GetModal(jqc.consulteeResponseModal, ModalAction.Hide);
                    Utilities.GetModal(jqc.legalEventsEdit_ConsultationEditModal, ModalAction.Show);
                }
            });
        });
    }

    public openEditConsulteeOtherModal = (consultationID: number, contactRef: string): void => {
        const self = this;

        Utilities.BlockUI();
        Utilities.GetModal(jqc.legalEventsEdit_ConsultationEditModal, ModalAction.Hide);
        Utilities.GetControl(jqc.placeholder_for_legalmodals2).load('/Consultations/ConsulteeResponseOtherView', { consultationID: consultationID, contactRef: contactRef, showResponseDate: true }, function (response, status, xhr) {
            if (xhr.status === 401) {//redirect to login in unauthorised
                window.location.href = window.G_SITEFOLDERNAME +'/account/login?ReturnUrl=' + encodeURIComponent(window.location.pathname);
            }
            Utilities.UnBlockUI();

            Utilities.GetModal(jqc.consulteeResponseOtherModal, ModalAction.Create);
            
            // Save the original state of the edit form
            var originalFormData = Utilities.GetControl(jqc.consulteeResponseOtherForm).serialize();

            Utilities.GetControl(jqc.consulteeResponseOtherSubmitBtn).on('click', function (evt) {
                var data = {};
                var formData = Utilities.GetControl(jqc.consulteeResponseOtherForm).serializeArray();
                formData.forEach(d => { if (data[d.name] == undefined) data[d.name] = d.value; });
                //data['ResponseDate'] = new Date(Date.now()).toLocaleString().split(',')[0];

                let url = "/Consultations/UpdateConsulteeResponseOther";
                let query = { data: data };

                $.post(url, query,
                    function (result: IAPIResult) {
                        try {
                            if (result.success == true) {
                                toastr.info('Updated response!')
                                Utilities.GetModal(jqc.consulteeResponseOtherModal, ModalAction.Hide);
                                Utilities.GetModal(jqc.legalEventsEdit_ConsultationEditModal, ModalAction.Show);
                                self.GetLegalConsulteeOtherData(consultationID);
                            }
                            else {
                                toastr.info('Failed to update response!')
                            }
                        }
                        catch (err) {
                            console.log(err);
                            alert(err);
                        }
                    }
                ).fail(function (xhr) {
                    if (xhr.status === 401) {//redirect to login in unauthorised
                        window.location.href = window.G_SITEFOLDERNAME +'/account/login?ReturnUrl=' + encodeURIComponent(window.location.pathname);
                    }
                });
            });

            Utilities.GetControl(jqc.consulteeResponseOtherCloseBtn).on('click', function (evt) {
                if (originalFormData !== Utilities.GetControl(jqc.consulteeResponseOtherForm).serialize()) {
                    Utilities.CloseFormWithPrompt().then(r => {
                        if (r == true) {
                            Utilities.GetModal(jqc.consulteeResponseOtherModal, ModalAction.Hide);
                            Utilities.GetModal(jqc.legalEventsEdit_ConsultationEditModal, ModalAction.Show);
                        }
                    });
                }
                else {
                    Utilities.GetModal(jqc.consulteeResponseOtherModal, ModalAction.Hide);
                    Utilities.GetModal(jqc.legalEventsEdit_ConsultationEditModal, ModalAction.Show);
                }
            });

            Utilities.GetControl(jqc.consulteeResponseOtherCancelBtn).on('click', function (evt) {
                if (originalFormData !== Utilities.GetControl(jqc.consulteeResponseOtherForm).serialize()) {
                    Utilities.CloseFormWithPrompt().then(r => {
                        if (r == true) {
                            Utilities.GetModal(jqc.consulteeResponseOtherModal, ModalAction.Hide);
                            Utilities.GetModal(jqc.legalEventsEdit_ConsultationEditModal, ModalAction.Show);
                        }
                    });
                }
                else {
                    Utilities.GetModal(jqc.consulteeResponseOtherModal, ModalAction.Hide);
                    Utilities.GetModal(jqc.legalEventsEdit_ConsultationEditModal, ModalAction.Show);
                }
            });
        });
    }

    public openAddConsultationModal = (legalCode: string): void => {
        const self = this;

        // Hide the modal
        Utilities.BlockUI();
        var currentScrollPosition = Utilities.GetControl(jqc.legalEventsEditModal).scrollTop();
        Utilities.GetModal(jqc.legalEventsEditModal, ModalAction.Hide);

        // Check if this is the first consultation, if it is, ask the user if they want a pre-consultation first
        var table: any = Utilities.GetControl(jqc.legalEventsEditConsultationsTable);
        var tableData = table.bootstrapTable('getData');
        if (tableData == null || tableData.length == 0) {
            //let promptData: IPromptYesNoViewModel = { title: "Pre-consultation", body: "Do you want to create a pre-consultation first?", yesBtn: "Yes, create a pre-consultation", noBtn: "No, create the first consultation" };
            //Utilities.GetControl(jqc.placeholder_for_promptModals).load('/PromptModals/PromptYesNoModal', promptData, function (response, status, xhr) {
            //    Utilities.GetModal(jqc.promptYesNoModal, ModalAction.Create);
            //    Utilities.GetControl(jqc.promptModalYesBtn).on('click', function (evt) { evt.preventDefault(); Utilities.GetModal(jqc.promptYesNoModal, ModalAction.Hide); createConsultation(true); });
            //    Utilities.GetControl(jqc.promptModalNoBtn).on('click', function (evt) { evt.preventDefault(); Utilities.GetModal(jqc.promptYesNoModal, ModalAction.Hide); createConsultation(false); });
            //});
        }
        else {
            createConsultation(false);
        }

        // Popup the edit form
        function createConsultation(createPreConsultation: boolean) {
            Utilities.GetControl(jqc.placeholder_for_legalmodals).load('/Legal/LegalEventsEdit_ConsultationAddView', { legalCode: legalCode, createPreConsultation: createPreConsultation }, function (response, status, xhr) {
                if (xhr.status === 401) {//redirect to login in unauthorised
                    window.location.href = window.G_SITEFOLDERNAME +'/account/login?ReturnUrl=' + encodeURIComponent(window.location.pathname);
                }
                else if (xhr.status === 500) {
                    toastr.error('Could not create another consultation!')
                    Utilities.BlockUI();
                    Utilities.GetModal(jqc.legalEventsEditModal, ModalAction.Show);
                }

                Utilities.UnBlockUI();
                Utilities.GetModal(jqc.legalEventsEdit_ConsultationAddModal, ModalAction.Create);

                Utilities.GetControl(jqc.legalEventsEdit_ConsultationAddModal + ' [name="StartDate"]').on('change', function () {
                    if ($(this).val() != null) {
                        var startDate = new Date($(this).val().toString());
                        var newDateStr = moment(startDate).add(1, 'month').format("DD-MMM-YYYY");
                        Utilities.GetControl(jqc.legalEventsEdit_ConsultationAddModal + ' [name="EndDate"]').val(newDateStr);
                    }
                });

                // Get form validation
                Utilities.InitFormValidation(Utilities.GetControl(jqc.legalEventsEdit_ConsultationAddModal));

                Utilities.GetControl(jqc.legalEventsEdit_ConsultationAddSubmitBtn).on('click', function (evt) {
                    evt.preventDefault();

                    // Validate
                    let form: any = Utilities.GetControl(jqc.legalEventsEdit_ConsultationAddForm);
                    if (Utilities.CheckFormValidation(form)==false) return;

                    Utilities.BlockUI($(jqc.legalEventsEdit_ConsultationAddModal + " .modal-content"));
                    let formData = new FormData(<any>Utilities.GetControl(jqc.legalEventsEdit_ConsultationAddForm)[0]);
                    $.ajax({
                        type: "POST",
                        processData: false,
                        contentType: false,
                        enctype: 'multipart/form-data',
                        url: '/Legal/AddConsultationToLegalEvent',
                        data: formData,
                        success: function (result: IAPIResult) {
                            Utilities.UnBlockUI($(jqc.legalEventsEdit_ConsultationAddModal + " .modal-content"));
                            try {
                                if (result.success == true) {
                                    toastr.info('Added consultation!')
                                    self.GetLegalConsultationData({ code: legalCode });
                                    Utilities.GetModal(jqc.legalEventsEdit_ConsultationAddModal, ModalAction.Hide);
                                    self.openEditConsultationModal(legalCode, result.consultationID);
                                    Utilities.GetControl(jqc.legalEventsEditModal).scrollTop(currentScrollPosition);
                                }
                                else {
                                    if (result.message != null) toastr.error(result.message)
                                    else toastr.error('Failed to create consultation!')
                                }
                            }
                            catch (err) {
                                console.log(err);
                                alert(err);
                            }
                        }
                    }).fail(function (xhr) {
                        if (xhr.status === 401) {//redirect to login in unauthorised
                            window.location.href = window.G_SITEFOLDERNAME +'/account/login?ReturnUrl=' + encodeURIComponent(window.location.pathname);
                        }
                    });
                });

                Utilities.GetControl(jqc.legalEventsEdit_ConsultationAddCloseBtn).on('click', function (evt) {
                    Utilities.GetModal(jqc.legalEventsEdit_ConsultationAddModal, ModalAction.Hide);
                    Utilities.GetModal(jqc.legalEventsEditModal, ModalAction.Show);
                    self.GetLegalConsultationData({ code: legalCode });
                    Utilities.GetControl(jqc.legalEventsEditModal).scrollTop(currentScrollPosition);
                });

                Utilities.GetControl(jqc.legalEventsEdit_ConsultationAddCancelBtn).on('click', function (evt) {
                    Utilities.GetModal(jqc.legalEventsEdit_ConsultationAddModal, ModalAction.Hide);
                    Utilities.GetModal(jqc.legalEventsEditModal, ModalAction.Show);
                    self.GetLegalConsultationData({ code: legalCode });
                    Utilities.GetControl(jqc.legalEventsEditModal).scrollTop(currentScrollPosition);
                });
            });
        }
    }

    public openEditConsultationModal = (legalCode: string, consultationID: number): void => {
        const self = this;
        Utilities.BlockUI();
        var currentScrollPosition = Utilities.GetControl(jqc.legalEventsEditModal).scrollTop();

        Utilities.GetModal(jqc.legalEventsEditModal, ModalAction.Hide);
        Utilities.GetControl(jqc.placeholder_for_legalmodals).load('/Legal/LegalEventsEdit_ConsultationEditView', { consultationID: consultationID }, function (response, status, xhr) {
            if (xhr.status === 401) {//redirect to login in unauthorised
                window.location.href = window.G_SITEFOLDERNAME +'/account/login?ReturnUrl=' + encodeURIComponent(window.location.pathname);
            }
            Utilities.UnBlockUI();

            Utilities.GetModal(jqc.legalEventsEdit_ConsultationEditModal, ModalAction.Create);
            Utilities.GetControl(jqc.legalEventsEdit_ConsultationEditModal_StatutoryConsultees_AddPanel).hide();
            Utilities.GetControl(jqc.legalEventsEdit_ConsultationEditModal_OwnerConsultees_AddPanel).hide();

            // ******************************************************************
            // Initialize Statutory action btns
            self.actionConsultationBtns = {
                copy: { btn: $(jqc.legalEventsEdit_ConsultationEditCopyBtn + ' button'), enable: false },
                new: { btn: $(jqc.legalEventsEdit_ConsultationEditAddBtn + ' button'), enable: false },
                delete: { btn: $(jqc.legalEventsEdit_ConsultationEditDeleteBtn + ' button'), enable: false },
                edit: { btn: $(jqc.legalEventsEdit_ConsultationEditEditBtn + ' button'), enable: false },
                print: { btn: $(jqc.legalEventsEdit_ConsultationEditPrintBtn + ' button'), enable: false }
            };

            self.actionConsultationBtns.copy.btn.on('click', function () {
                //let promptData: IPromptYesNoViewModel = { title: "Confirm", body: "Are you sure you want to copy all consultees from from the previous consultation stage?", yesBtn: "Yes", noBtn: "No" };
                //Utilities.GetControl(jqc.placeholder_for_promptModals).load('/PromptModals/PromptYesNoModal', promptData, function (response, status, xhr) {
                //    Utilities.GetModal(jqc.promptYesNoModal, ModalAction.Create);
                //    Utilities.GetControl(jqc.promptModalYesBtn).on('click', function (evt) { evt.preventDefault(); Utilities.GetModal(jqc.promptYesNoModal, ModalAction.Hide); self.CopyConsulteesFromPreviousStage(consultationID, true); });
                //    Utilities.GetControl(jqc.promptModalNoBtn).on('click', function (evt) { evt.preventDefault(); Utilities.GetModal(jqc.promptYesNoModal, ModalAction.Hide); });
                //});
            });
            self.actionConsultationBtns.new.btn.on('click', function () { Utilities.GetControl(jqc.legalEventsEdit_ConsultationEditModal_StatutoryConsultees_AddPanel).show(); });
            self.actionConsultationBtns.delete.btn.on('click', function () {
                // Make sure only consultee's with no response date are selected
                var table: any = Utilities.GetControl(jqc.legalEventsEdit_ConsultationEdit_ConsulteeTable)
                let rows: Array<any> = table.bootstrapTable('getSelections');
                if (rows.find(f => f.ResponseDate != null) != null) {
                    toastr.error("You can only remove consultee's who have not yet submitted a response!");
                    return;
                }

                //let promptData: IPromptYesNoViewModel = { title: "Confirm", body: "Are you sure you want to remove the consultee(s)?", yesBtn: "Yes", noBtn: "No" };
                //Utilities.GetControl(jqc.placeholder_for_promptModals).load('/PromptModals/PromptYesNoModal', promptData, function (response, status, xhr) {
                //    Utilities.GetModal(jqc.promptYesNoModal, ModalAction.Create);
                //    Utilities.GetControl(jqc.promptModalYesBtn).on('click', function (evt) { evt.preventDefault(); Utilities.GetModal(jqc.promptYesNoModal, ModalAction.Hide); doDelete(); });
                //    Utilities.GetControl(jqc.promptModalNoBtn).on('click', function (evt) { evt.preventDefault(); Utilities.GetModal(jqc.promptYesNoModal, ModalAction.Hide); });
                //});

                function doDelete() {
                    var table: any = Utilities.GetControl(jqc.legalEventsEdit_ConsultationEdit_ConsulteeTable)
                    let rows: Array<any> = table.bootstrapTable('getSelections');
                    let IDs: Array<any> = [];
                    rows.forEach(r => IDs.push(r.ID));
                    self.DeleteConsultee(IDs, consultationID, true);
                }
            });
            self.actionConsultationBtns.edit.btn.on('click', function () {
                var table: any = Utilities.GetControl(jqc.legalEventsEdit_ConsultationEdit_ConsulteeTable)
                let rows: Array<any> = table.bootstrapTable('getSelections');
                self.openEditConsulteeModal(consultationID, rows[0].ContactRef);
            });
            self.actionConsultationBtns.print.btn.on('click', function () { toastr.info('To be completed'); });

            // ******************************************************************
            // Initialize Owner action btns
            self.actionConsultationOtherBtns = {
                copy: { btn: $(jqc.legalEventsEdit_ConsultationOtherEditCopyBtn + ' button'), enable: false },
                new: { btn: $(jqc.legalEventsEdit_ConsultationOtherEditAddBtn + ' button'), enable: false },
                delete: { btn: $(jqc.legalEventsEdit_ConsultationOtherEditDeleteBtn + ' button'), enable: false },
                edit: { btn: $(jqc.legalEventsEdit_ConsultationOtherEditEditBtn + ' button'), enable: false },
                print: { btn: $(jqc.legalEventsEdit_ConsultationOtherEditPrintBtn + ' button'), enable: false },
                import: { btn: $(jqc.legalEventsEdit_ConsultationOtherEditImportBtn + ' button'), enable: false }
            };

            self.actionConsultationOtherBtns.copy.btn.on('click', function () {
                //let promptData: IPromptYesNoViewModel = { title: "Confirm", body: "Are you sure you want to copy all consultees from from the previous consultation stage?", yesBtn: "Yes", noBtn: "No" };
                //Utilities.GetControl(jqc.placeholder_for_promptModals).load('/PromptModals/PromptYesNoModal', promptData, function (response, status, xhr) {
                //    Utilities.GetModal(jqc.promptYesNoModal, ModalAction.Create);
                //    Utilities.GetControl(jqc.promptModalYesBtn).on('click', function (evt) { evt.preventDefault(); Utilities.GetModal(jqc.promptYesNoModal, ModalAction.Hide); self.CopyConsulteesFromPreviousStage(consultationID, false); });
                //    Utilities.GetControl(jqc.promptModalNoBtn).on('click', function (evt) { evt.preventDefault(); Utilities.GetModal(jqc.promptYesNoModal, ModalAction.Hide); });
                //});
            });
            self.actionConsultationOtherBtns.new.btn.on('click', function () { Utilities.GetControl(jqc.legalEventsEdit_ConsultationEditModal_OwnerConsultees_AddPanel).show(); });
            self.actionConsultationOtherBtns.delete.btn.on('click', function () {
                // Make sure only consultee's with no response date are selected
                var table: any = Utilities.GetControl(jqc.legalEventsEdit_ConsultationEdit_ConsulteeOtherTable)
                let rows: Array<any> = table.bootstrapTable('getSelections');
                if (rows.find(f => f.ResponseDate != null) != null) {
                    toastr.error("You can only remove consultee's who have not yet submitted a response!");
                    return;
                }

                //let promptData: IPromptYesNoViewModel = { title: "Confirm", body: "Are you sure you want to remove the consultee(s)?", yesBtn: "Yes", noBtn: "No" };
                //Utilities.GetControl(jqc.placeholder_for_promptModals).load('/PromptModals/PromptYesNoModal', promptData, function (response, status, xhr) {
                //    Utilities.GetModal(jqc.promptYesNoModal, ModalAction.Create);
                //    Utilities.GetControl(jqc.promptModalYesBtn).on('click', function (evt) { evt.preventDefault(); Utilities.GetModal(jqc.promptYesNoModal, ModalAction.Hide); doDelete(); });
                //    Utilities.GetControl(jqc.promptModalNoBtn).on('click', function (evt) { evt.preventDefault(); Utilities.GetModal(jqc.promptYesNoModal, ModalAction.Hide); });
                //});

                function doDelete() {
                    var table: any = Utilities.GetControl(jqc.legalEventsEdit_ConsultationEdit_ConsulteeOtherTable)
                    let rows: Array<any> = table.bootstrapTable('getSelections');
                    let IDs: Array<any> = [];
                    rows.forEach(r => IDs.push(r.ID));
                    self.DeleteConsultee(IDs, consultationID, false);
                }

            });
            self.actionConsultationOtherBtns.edit.btn.on('click', function () {
                var table: any = Utilities.GetControl(jqc.legalEventsEdit_ConsultationEdit_ConsulteeOtherTable);
                let rows: Array<any> = table.bootstrapTable('getSelections');
                self.openEditConsulteeOtherModal(consultationID, rows[0].ContactRef);
            });
            self.actionConsultationOtherBtns.print.btn.on('click', function () { toastr.info('To be completed'); });
            self.actionConsultationOtherBtns.import.btn.on('click', function () { toastr.info('To be completed'); });

            // ******************************************************************
            // Add consultee btns
            ($(jqc.legalEventsEdit_ConsultationEditModal + ' [name="groupContact"]') as any).multiselect({ buttonWidth: '100%', widthSynchronizationMode: 'always', buttonTextAlignment: 'left' });
            Utilities.GetControl(jqc.legalEventsEdit_ConsultationEdit_AddConsultee_SingleContactBtn).on('click', function (evt) { addConsultee(false, true); });
            Utilities.GetControl(jqc.legalEventsEdit_ConsultationEdit_AddConsultee_GroupContactBtn).on('click', function (evt) { addConsultee(true, true); });
            Utilities.GetControl(jqc.legalEventsEdit_ConsultationEdit_AddConsultee_contactSearch).on('click', function () {
                // Open the contacts list view
                let btns = new ContactListConfig();
                btns.ActionBtns.account.visible = false;
                btns.ActionBtns.export.visible = false;
                btns.ActionBtns.query.visible = false;
                btns.ActionBtns.viewprint.visible = false;
                btns.AllowMultipleSelection = true;
                events.bus.publish(events.eventOpenContactsListView([false, btns, callback]));

                function callback(contact: Array<ICAMSContact>) {
                    var contactList = contact.map(c => c.ContactRef).join(',');
                    var listName = contact.map(c => c.ListName).join(', ');
                    $(jqc.legalEventsEdit_ConsultationEditModal + ' [name="singleContact"]').val(listName);
                    $(jqc.legalEventsEdit_ConsultationEditModal + ' [name="singleContact_ContactRef"]').val(contactList);
                }
            });

            // Add consultee other btns
            // ******************************************************************
            // Add consultee btns
            ($(jqc.legalEventsEdit_ConsultationEditModal + ' [name="groupOtherContact"]') as any).multiselect({ buttonWidth: '100%', widthSynchronizationMode: 'always', buttonTextAlignment: 'left' });
            Utilities.GetControl(jqc.legalEventsEdit_ConsultationEdit_AddConsulteeOther_SingleContactBtn).on('click', function (evt) { addConsultee(false, false); });
            Utilities.GetControl(jqc.legalEventsEdit_ConsultationEdit_AddConsulteeOther_ManualAddressBtn).on('click', function (evt) {
                var address = $(jqc.legalEventsEdit_ConsultationEditModal + ' [name="manualAddress"]').val();

                Utilities.BlockUI($(jqc.legalEventsEdit_ConsultationEditModal + " .modal-content"));
                $.post('/Consultations/AddConsulteeOtherAddress', { address: address, consultationID: consultationID },
                    function (result: IAPIResult) {
                        Utilities.UnBlockUI($(jqc.legalEventsEdit_ConsultationEditModal + " .modal-content"));
                        try {
                            if (result.success == true) {
                                toastr.info('Added address!')
                                $(jqc.legalEventsEdit_ConsultationEditModal + ' [name="manualAddress"]').val("");
                                Utilities.GetControl(jqc.legalEventsEdit_ConsultationEditModal_OwnerConsultees_AddPanel).hide();
                                self.GetLegalConsulteeOtherData(consultationID);
                            }
                            else {
                                if (result.message == null) toastr.error('Failed to add address!');
                                else toastr.error(result.message);
                            }
                        }
                        catch (err) {
                            console.log(err);
                            alert(err);
                        }
                    }
                ).fail(function (xhr) {
                    if (xhr.status === 401) {//redirect to login in unauthorised
                        window.location.href = window.G_SITEFOLDERNAME +'/account/login?ReturnUrl=' + encodeURIComponent(window.location.pathname);
                    }
                });

            });
            Utilities.GetControl(jqc.legalEventsEdit_ConsultationEdit_AddConsulteeOther_GroupContactBtn).on('click', function (evt) { addConsultee(true, false); });
            Utilities.GetControl(jqc.legalEventsEdit_ConsultationEdit_AddConsulteeOther_contactSearch).on('click', function () {
                // Open the contacts list view
                let btns = new ContactListConfig();
                btns.ActionBtns.account.visible = false;
                btns.ActionBtns.export.visible = false;
                btns.ActionBtns.query.visible = false;
                btns.ActionBtns.viewprint.visible = false;
                btns.AllowMultipleSelection = true;
                events.bus.publish(events.eventOpenContactsListView([false, btns, callback]));

                function callback(contact: Array<ICAMSContact>) {
                    var contactList = contact.map(c => c.ContactRef).join(',');
                    var listName = contact.map(c => c.ListName).join(', ');
                    $(jqc.legalEventsEdit_ConsultationEditModal + ' [name="singleOtherContact"]').val(listName);
                    $(jqc.legalEventsEdit_ConsultationEditModal + ' [name="singleOtherContact_ContactRef"]').val(contactList);
                }
            });

            function addConsultee(isContactGroup: boolean, isStatutoryConsultee: boolean) {
                let query: Array<any> = [];
                var reportID = $(jqc.legalEventsEdit_ConsultationEditModal + ' [name="ReportID"]').val().toString();

                // Get contacts selected by the user
                var contactType; var contactRefs = []; var url; var contactTypeCount = 0;
                if (isStatutoryConsultee == true) {
                    url = '/Consultations/AddConsultees';
                    if (isContactGroup == true) {
                        contactType = $(jqc.legalEventsEdit_ConsultationEditModal + ' [name="groupContact"]').val().toString();
                        $('#legalEventsEdit_ConsultationEditModal [name="groupContact"] option:selected').each(function () {
                            var a = $(this).text().indexOf('(');
                            var b = $(this).text().indexOf(')');
                            if (a > 0 && b > 0) contactTypeCount += parseInt($(this).text().substring(a+1, b));
                        });
                    }
                    else {
                        contactRefs = $(jqc.legalEventsEdit_ConsultationEditModal + ' [name="singleContact_ContactRef"]').val().toString().split(',');
                    }

                }
                else {
                    url = '/Consultations/AddConsulteeOthers';
                    if (isContactGroup == true) {
                        contactType = $(jqc.legalEventsEdit_ConsultationEditModal + ' [name="groupOtherContact"]').val().toString();
                    }
                    else {
                        contactRefs = $(jqc.legalEventsEdit_ConsultationEditModal + ' [name="singleOtherContact_ContactRef"]').val().toString().split(',');
                    }
                }

                contactRefs.forEach(function (c) {
                    if (c != "" && c != null) query.push({ ConsultationID: consultationID, ContactRef: c });
                });

                // Prompt the user what is happening
                var msg = "";
                if (isContactGroup == true) {
                    var groupCount = contactType.split(',') == null ? 0 : contactType.split(',').filter(f => f != "").length;
                    if (groupCount == 0) {
                        toastr.error("Please select at least one contact group to add!");
                        return;
                    }
                    msg = `Adding ${contactTypeCount} consultees.`
                }
                else {
                    var contactCount = query.length;
                    if (contactCount == 0) {
                        toastr.error("Please select at least one contact to add!");
                        return;
                    }
                    msg = `Adding ${contactCount} consultees.`
                }
                
                //let promptData: IPromptYesNoViewModel = { title: "Confirm", body: msg, yesBtn: "OK", noBtn: "Cancel" };
                //Utilities.GetControl(jqc.placeholder_for_promptModals).load('/PromptModals/PromptYesNoModal', promptData, function (response, status, xhr) {
                //    Utilities.GetModal(jqc.promptYesNoModal, ModalAction.Create);
                //    Utilities.GetControl(jqc.promptModalYesBtn).on('click', function (evt) { evt.preventDefault(); Utilities.GetModal(jqc.promptYesNoModal, ModalAction.Hide); doAdd(); });
                //    Utilities.GetControl(jqc.promptModalNoBtn).on('click', function (evt) { evt.preventDefault(); Utilities.GetModal(jqc.promptYesNoModal, ModalAction.Hide); });
                //});

                function doAdd() {
                    Utilities.BlockUI();
                    $.post(url, { data: query, contactType: contactType, consultationID: consultationID, reportID: reportID },
                        function (result: IAPIResult) {
                            Utilities.UnBlockUI();
                            try {
                                if (result.success == true) {
                                    toastr.info('Added consultees!')
                                    if (isStatutoryConsultee == true) {
                                        ($(jqc.legalEventsEdit_ConsultationEditModal + ' [name="groupContact"]') as any).multiselect('deselectAll');
                                        $(jqc.legalEventsEdit_ConsultationEditModal + ' [name="singleContact"]').val("");
                                        Utilities.GetControl(jqc.legalEventsEdit_ConsultationEditModal_StatutoryConsultees_AddPanel).hide();
                                        self.GetLegalConsulteeData(consultationID);
                                    }
                                    else {
                                        ($(jqc.legalEventsEdit_ConsultationEditModal + ' [name="groupOtherContact"]') as any).multiselect('deselectAll');
                                        $(jqc.legalEventsEdit_ConsultationEditModal + ' [name="singleOtherContact"]').val("");
                                        Utilities.GetControl(jqc.legalEventsEdit_ConsultationEditModal_OwnerConsultees_AddPanel).hide();
                                        self.GetLegalConsulteeOtherData(consultationID);
                                    }   
                                }
                                else {
                                    if (result.message == null) toastr.error('Failed to add consultee!');
                                    else toastr.error(result.message);
                                }
                            }
                            catch (err) {
                                console.log(err);
                                alert(err);
                            }
                        }
                    ).fail(function (xhr) {
                        if (xhr.status === 401) {//redirect to login in unauthorised
                            window.location.href = window.G_SITEFOLDERNAME +'/account/login?ReturnUrl=' + encodeURIComponent(window.location.pathname);
                        }
                    });
                }
            }

            // ******************************************************************
            // Initialize  Statutory action table
            var table: any = Utilities.GetControl(jqc.legalEventsEdit_ConsultationEdit_ConsulteeTable)
            table.bootstrapTable();

            table.on('check.bs.table', function (e, row, $element) {
                self.checkVisibleButtons_ConsultationTable();
            });
            table.on('check-all.bs.table', function (e, rowsAfter, rowsBefore) {
                self.checkVisibleButtons_ConsultationTable();
            });
            table.on('uncheck.bs.table', function (e, row, $element) {
                self.checkVisibleButtons_ConsultationTable();
            });
            table.on('uncheck-all.bs.table', function (e, rowsAfter, rowsBefore) {
                self.checkVisibleButtons_ConsultationTable();
            });

            // ******************************************************************
            // Initialize Owner action table
            var table: any = Utilities.GetControl(jqc.legalEventsEdit_ConsultationEdit_ConsulteeOtherTable);
            table.bootstrapTable();

            table.on('check.bs.table', function (e, row, $element) {
                self.checkVisibleButtons_ConsultationOtherTable();
            });
            table.on('check-all.bs.table', function (e, rowsAfter, rowsBefore) {
                self.checkVisibleButtons_ConsultationOtherTable();
            });
            table.on('uncheck.bs.table', function (e, row, $element) {
                self.checkVisibleButtons_ConsultationOtherTable();
            });
            table.on('uncheck-all.bs.table', function (e, rowsAfter, rowsBefore) {
                self.checkVisibleButtons_ConsultationOtherTable();
            });

            // ******************************************************************
            // Initialise photo uploader
            self.photos.setupUploader(jqc.legalEventsEdit_ConsultationEditModal);

            // Get form validation
            Utilities.InitFormValidation(Utilities.GetControl(jqc.legalEventsEdit_ConsultationEditModal));

            Utilities.GetControl(jqc.legalEventsEdit_ConsultationEditSubmitBtn).on('click', function (evt) {

                // Validate
                let form: any = Utilities.GetControl(jqc.legalEventsEdit_ConsultationEditForm);
                if (Utilities.CheckFormValidation(form)==false) return;

                Utilities.BlockUI();
                let formData = new FormData(<any>Utilities.GetControl(jqc.legalEventsEdit_ConsultationEditForm)[0]);
                $.ajax({
                    type: "POST",
                    processData: false,
                    contentType: false,
                    enctype: 'multipart/form-data',
                    url: '/Consultations/UpdateConsultation',
                    data: formData,
                    success: function (result: IAPIResult) {
                        Utilities.UnBlockUI();
                        try {
                            if (result.success == true) {
                                toastr.info('Updated consultation!')
                                Utilities.GetModal(jqc.legalEventsEdit_ConsultationEditModal, ModalAction.Hide);
                                Utilities.GetModal(jqc.legalEventsEditModal, ModalAction.Show);
                                self.GetLegalConsultationData({ code: legalCode });
                                Utilities.GetControl(jqc.legalEventsEditModal).scrollTop(currentScrollPosition);
                            }
                            else {
                                if (result.message != null) toastr.error(result.message)
                                else toastr.error('Failed to create consultation!')
                            }
                        }
                        catch (err) {
                            console.log(err);
                            alert(err);
                        }
                    }
                }).fail(function (xhr) {
                    if (xhr.status === 401) {//redirect to login in unauthorised
                        window.location.href = window.G_SITEFOLDERNAME +'/account/login?ReturnUrl=' + encodeURIComponent(window.location.pathname);
                    }
                });
            });

            // ******************************************************************
            // Save the original state of the edit form
            var originalFormData = Utilities.GetControl(jqc.legalEventsEdit_ConsultationEditForm).serialize();

            Utilities.GetControl(jqc.legalEventsEdit_ConsultationEditCloseBtn).on('click', function (evt) {
                if (originalFormData !== Utilities.GetControl(jqc.legalEventsEdit_ConsultationEditForm).serialize()) {
                    Utilities.CloseFormWithPrompt().then(r => {
                        if (r == true) {
                            Utilities.GetModal(jqc.legalEventsEdit_ConsultationEditModal, ModalAction.Hide);
                            Utilities.GetModal(jqc.legalEventsEditModal, ModalAction.Show);
                            self.GetLegalConsultationData({ code: legalCode });
                            Utilities.GetControl(jqc.legalEventsEditModal).scrollTop(currentScrollPosition);
                        }
                    });
                }
                else {
                    Utilities.GetModal(jqc.legalEventsEdit_ConsultationEditModal, ModalAction.Hide);
                    Utilities.GetModal(jqc.legalEventsEditModal, ModalAction.Show);
                    self.GetLegalConsultationData({ code: legalCode });
                    Utilities.GetControl(jqc.legalEventsEditModal).scrollTop(currentScrollPosition);
                }
            });

            Utilities.GetControl(jqc.legalEventsEdit_ConsultationEditCancelBtn).on('click', function (evt) {
                if (originalFormData !== Utilities.GetControl(jqc.legalEventsEdit_ConsultationEditForm).serialize()) {
                    Utilities.CloseFormWithPrompt().then(r => {
                        if (r == true) {
                            Utilities.GetModal(jqc.legalEventsEdit_ConsultationEditModal, ModalAction.Hide);
                            Utilities.GetModal(jqc.legalEventsEditModal, ModalAction.Show);
                            self.GetLegalConsultationData({ code: legalCode });
                            Utilities.GetControl(jqc.legalEventsEditModal).scrollTop(currentScrollPosition);
                        }
                    });
                }
                else {
                    Utilities.GetModal(jqc.legalEventsEdit_ConsultationEditModal, ModalAction.Hide);
                    Utilities.GetModal(jqc.legalEventsEditModal, ModalAction.Show);
                    self.GetLegalConsultationData({ code: legalCode });
                    Utilities.GetControl(jqc.legalEventsEditModal).scrollTop(currentScrollPosition);
                }
            });

            Utilities.GetControl(jqc.legalEventsEdit_ConsultationEditConsultBtn).on('click', function (evt) {
                // Pop up warning msg first
                var statutoryTable: any = Utilities.GetControl(jqc.legalEventsEdit_ConsultationEdit_ConsulteeTable);
                var otherTable: any = Utilities.GetControl(jqc.legalEventsEdit_ConsultationEdit_ConsulteeOtherTable);
                var count = statutoryTable.bootstrapTable('getData').length + otherTable.bootstrapTable('getData').length;
                var missing = (otherTable.bootstrapTable('getData') as Array<any>).filter(f => f.Consulted != true && f.ResponseDate == null).length;
                var msg = `${count - missing} consultation(s) will be sent. `;
                if (missing > 0) msg += `Warning, there are ${missing} Owner/Occupier consultation(s) that will not been generated`;

                if (count - missing < 1) {
                    toastr.error("There are no valid consultations to send.");
                    return;
                }

                //let promptData: IPromptYesNoViewModel = { title: "Consult", body: msg, yesBtn: "Send consultations", noBtn: "Cancel" };
                //Utilities.GetControl(jqc.placeholder_for_promptModals).load('/PromptModals/PromptYesNoModal', promptData, function (response, status, xhr) {
                //    Utilities.GetModal(jqc.promptYesNoModal, ModalAction.Create);
                //    Utilities.GetControl(jqc.promptModalYesBtn).on('click', function (evt) { evt.preventDefault(); Utilities.GetModal(jqc.promptYesNoModal, ModalAction.Hide); self.SendConsulteesNotification(consultationID) });
                //    Utilities.GetControl(jqc.promptModalNoBtn).on('click', function (evt) { evt.preventDefault(); Utilities.GetModal(jqc.promptYesNoModal, ModalAction.Hide); });
                //});

            });

            // Get consultee data
            self.GetLegalConsulteeData(consultationID);
            self.GetLegalConsulteeOtherData(consultationID);
        });
    }

    // ----------------------------------------------------------- //
    // GET DATA FROM SERVER
    private GetLegalConsultationData = (data: ICAMSKey): void => {
        const self = this;
     
        let url = "/Consultations/GetConsultationsByLegaLCode";
        let query = { legalCode: data.code };

        $.post(url, query,
            function (result: IAPIResult) {
                try {
                    if (result.success == true) {
                        var data: Array<any> = JSON.parse(result.data);

                        // Calculate the number of responses
                        if (data != null) {
                            data.forEach(d => {
                                if (d.ConsultationConsultees != null) {
                                    d.NoConsultees = d.ConsultationConsultees.length;
                                    d.ResponseCount = d.ConsultationConsultees.filter(x => x.ResponseDate != null).length;
                                }
                            });                 
                        }

                        var table: any = Utilities.GetControl(jqc.legalEventsEditConsultationsTable)
                        table.bootstrapTable('load', data);
                        self.checkVisibleButtons_StageTable();
                    }
                    else {
                        toastr.error('Failed to get data!')
                    }
                }
                catch (err) {
                    console.log(err);
                    alert(err);
                }
            }
        ).fail(function (xhr) {
            if (xhr.status === 401) {//redirect to login in unauthorised
                window.location.href = window.G_SITEFOLDERNAME +'/account/login?ReturnUrl=' + encodeURIComponent(window.location.pathname);
            }
        });
    }

    private GetLegalConsulteeData = (consultationID: number): void => {
        const self = this;
     
        let url = "/Consultations/GetConsultees";
        let query = { consultationID: consultationID };

        $.post(url, query,
            function (result: IAPIResult) {
                try {
                    if (result.success == true) {
                        var data = JSON.parse(result.data);
                        var table: any = Utilities.GetControl(jqc.legalEventsEdit_ConsultationEdit_ConsulteeTable)
                        table.bootstrapTable('load', data)
                     
                        var count = data instanceof Array ? data.length : 0;
                        Utilities.GetControl(jqc.legalEventsEdit_ConsultationEdit_StatutoryConsultee_Count).html(` (${count})`);
                        self.checkVisibleButtons_ConsultationTable();
                    }
                    else {
                        toastr.error('Failed to get data!')
                    }
                }
                catch (err) {
                    console.log(err);
                    alert(err);
                }
            }
        ).fail(function (xhr) {
            if (xhr.status === 401) {//redirect to login in unauthorised
                window.location.href = window.G_SITEFOLDERNAME +'/account/login?ReturnUrl=' + encodeURIComponent(window.location.pathname);
            }
        });
    }

    private GetLegalConsulteeOtherData = (consultationID: number): void => {
        const self = this;

        let url = "/Consultations/GetConsulteeOthers";
        let query = { consultationID: consultationID };

        $.post(url, query,
            function (result: IAPIResult) {
                try {
                    if (result.success == true) {
                        var data = JSON.parse(result.data);
                        var table: any = Utilities.GetControl(jqc.legalEventsEdit_ConsultationEdit_ConsulteeOtherTable)
                        table.bootstrapTable('load', data)

                        var count = data instanceof Array ? data.length : 0;
                        Utilities.GetControl(jqc.legalEventsEdit_ConsultationEdit_OtherConsultee_Count).html(` (${count})`);
                        self.checkVisibleButtons_ConsultationOtherTable();
                    }
                    else {
                        toastr.error('Failed to get data!')
                    }
                }
                catch (err) {
                    console.log(err);
                    alert(err);
                }
            }
        ).fail(function (xhr) {
            if (xhr.status === 401) {//redirect to login in unauthorised
                window.location.href = window.G_SITEFOLDERNAME +'/account/login?ReturnUrl=' + encodeURIComponent(window.location.pathname);
            }
        });
    }

    private SendConsulteesNotification = (consultationID: number): void => {
        const self = this;

        let url = "/Consultations/SendConsulteesNotification";
        let query = { consultationID: consultationID };

        $.post(url, query,
            function (result: IAPIResult) {
                try {
                    if (result.success == true) {
                        toastr.success('Notifications sent!')
                    }
                    else {
                        toastr.error('Failed to send notifications!')
                    }
                }
                catch (err) {
                    console.log(err);
                    alert(err);
                }
            }
        ).fail(function (xhr) {
            if (xhr.status === 401) {//redirect to login in unauthorised
                window.location.href = window.G_SITEFOLDERNAME +'/account/login?ReturnUrl=' + encodeURIComponent(window.location.pathname);
            }
        });
    }

    private checkVisibleButtons_StageTable = (): void => {
        const self = this;
        var table: any = Utilities.GetControl(jqc.legalEventsEditConsultationsTable)
        let rows = table.bootstrapTable('getSelections');

        // Reset all btns first
        Object.keys(this.actionStageBtns).forEach(k => {
            self.actionStageBtns[k].enable = false;
        });

        // Then switch on the ones we want depending on the nde type
        self.actionStageBtns.new.enable = true;
        if (rows && rows.length == 1) {
            self.actionStageBtns.viewprint.enable = true;
            self.actionStageBtns.edit.enable = true;
            self.actionStageBtns.delete.enable = true;
            self.actionStageBtns.export.enable = true;
        }
        else if (rows && rows.length > 1) {

        }

        Object.keys(this.actionStageBtns).forEach(k => {
            if (self.actionStageBtns[k].enable == true) self.actionStageBtns[k].btn.prop("disabled", false);
            else self.actionStageBtns[k].btn.prop("disabled", true);
        });
    }

    private checkVisibleButtons_ConsultationTable = (): void => {
        const self = this;
        var table: any = Utilities.GetControl(jqc.legalEventsEdit_ConsultationEdit_ConsulteeTable)
        let rows = table.bootstrapTable('getSelections');

        // Reset all btns first
        Object.keys(this.actionConsultationBtns).forEach(k => {
            self.actionConsultationBtns[k].enable = false;
        });

        // Then switch on the ones we want depending on the nde type
        self.actionConsultationBtns.new.enable = true;
        self.actionConsultationBtns.copy.enable = true;
        if (rows && rows.length == 1) {
            self.actionConsultationBtns.delete.enable = true;
            self.actionConsultationBtns.edit.enable = true;
            self.actionConsultationBtns.print.enable = true;
        }
        else if (rows && rows.length > 1) {
            self.actionConsultationBtns.delete.enable = true;
        }

        Object.keys(this.actionConsultationBtns).forEach(k => {
            if (self.actionConsultationBtns[k].enable == true) self.actionConsultationBtns[k].btn.prop("disabled", false);
            else self.actionConsultationBtns[k].btn.prop("disabled", true);
        });
    }

    private checkVisibleButtons_ConsultationOtherTable = (): void => {
        const self = this;
        var table: any = Utilities.GetControl(jqc.legalEventsEdit_ConsultationEdit_ConsulteeOtherTable)
        let rows = table.bootstrapTable('getSelections');

        // Reset all btns first
        Object.keys(this.actionConsultationOtherBtns).forEach(k => {
            self.actionConsultationOtherBtns[k].enable = false;
        });

        // Then switch on the ones we want depending on the nde type
        self.actionConsultationOtherBtns.new.enable = true;
        self.actionConsultationOtherBtns.copy.enable = true;
        self.actionConsultationOtherBtns.import.enable = true;
        if (rows && rows.length == 1) {
            self.actionConsultationOtherBtns.delete.enable = true;
            self.actionConsultationOtherBtns.edit.enable = true;
            self.actionConsultationOtherBtns.print.enable = true;
        }
        else if (rows && rows.length > 1) {
            self.actionConsultationOtherBtns.delete.enable = true;
        }

        Object.keys(this.actionConsultationOtherBtns).forEach(k => {
            if (self.actionConsultationOtherBtns[k].enable == true) self.actionConsultationOtherBtns[k].btn.prop("disabled", false);
            else self.actionConsultationOtherBtns[k].btn.prop("disabled", true);
        });
    }

    // ----------------------------------------------------------- //
    // COPY CONSULTEES
    private CopyConsulteesFromPreviousStage = (consultationID: number, onlyCopyStatutoryConsultees: boolean): void => {
        const self = this;

        let url = "/Consultations/CopyConsulteesFromPreviousStage";
        let query = { consultationID: consultationID, onlyCopyStatutoryConsultees: onlyCopyStatutoryConsultees };

        $.post(url, query,
            function (result: IAPIResult) {
                try {
                    if (result.success == true) {
                        if (onlyCopyStatutoryConsultees == true) self.GetLegalConsulteeData(consultationID);
                        else self.GetLegalConsulteeOtherData(consultationID);
                        toastr.success('Added consultees!');
                    }
                    else {
                        if (result.message == null) toastr.error('Failed to copy consultees!');
                        else toastr.error(result.message);
                    }
                }
                catch (err) {
                    console.log(err);
                    toastr.error('Error copying consultees!');
                }
            }
        ).fail(function (xhr) {
            if (xhr.status === 401) {//redirect to login in unauthorised
                window.location.href = window.G_SITEFOLDERNAME +'/account/login?ReturnUrl=' + encodeURIComponent(window.location.pathname);
            }
        });
    }

    // ----------------------------------------------------------- //
    // DELETE FROM SERVER
    private DeleteConsulation = (consultationID: number, legalCode: string): void => {
        const self = this;

        let url = "/Consultations/DeleteConsultation";
        let query = { consultationID: consultationID };

        $.post(url, query,
            function (result: IAPIResult) {
                try {
                    if (result.success == true) {
                        self.GetLegalConsultationData({ code: legalCode });
                    }
                    else {
                        toastr.error(result.error)
                    }
                }
                catch (err) {
                    console.log(err);
                    alert(err);
                }
            }
        ).fail(function (xhr) {
            if (xhr.status === 401) {//redirect to login in unauthorised
                window.location.href = window.G_SITEFOLDERNAME +'/account/login?ReturnUrl=' + encodeURIComponent(window.location.pathname);
            }
        });
    }

    private DeleteConsultee = (IDs: Array<number>, consultationID: number, deleteStatutoryInstead: Boolean): void => {
        const self = this;

        let url = "/Consultations/DeleteConsulteeOther";
        if (deleteStatutoryInstead == true) url = "/Consultations/DeleteConsultee"
        let query = { IDs: IDs };

        $.post(url, query,
            function (result: IAPIResult) {
                try {
                    if (result.success == true) {
                        if (deleteStatutoryInstead == true) self.GetLegalConsulteeData(consultationID); 
                        else self.GetLegalConsulteeOtherData(consultationID);
                    }
                    else {
                        toastr.error('Failed to delete data!')
                    }
                }
                catch (err) {
                    console.log(err);
                    alert(err);
                }
            }
        ).fail(function (xhr) {
            if (xhr.status === 401) {//redirect to login in unauthorised
                window.location.href = window.G_SITEFOLDERNAME +'/account/login?ReturnUrl=' + encodeURIComponent(window.location.pathname);
            }
        });
    } 
}




